import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { addUrlProps, UrlQueryParamTypes, multiPushInUrlQuery } from 'react-url-query';
import { connect, PromiseState } from 'react-refetch';

import PromiseStateContainer from '../../apiAccess/PromiseStateContainer';
import BASE_URL from '../../apiAccess/urls';
import SearchNav from '../searchNav/SearchNav';
import BasicFoodQueryBuilder from './BasicFoodQueryBuilder';
import BasicFoodSearchResult from './BasicFoodSearchResult';
import { getValidGroup } from '../../util/util';
import PrintHeader from '../../presentation/Print/PrintHeader';
import PrintDisclaimer from '../../presentation/Print/PrintDisclaimer';

const urlPropsQueryConfig = {
  q: { type: UrlQueryParamTypes.string },
  group: { type: UrlQueryParamTypes.string },
  page: { type: UrlQueryParamTypes.number },
  size: { type: UrlQueryParamTypes.number },
  sort: { type: UrlQueryParamTypes.string },
  order: { type: UrlQueryParamTypes.string },
};

const handleSubmit = function(query) {
  // onChangeXXX does not push history. use multiPushInUrlQuery.
  multiPushInUrlQuery({
    q: query.q,
    group: query.group,
    page: '',
    sort: '',
    order: '',
  });
};

const handlePageChange = function(newPage, newSize) {
  multiPushInUrlQuery({
    page: newPage,
    size: newSize,
  });
};

const handleSortChange = function(newSortName, newSortOrder) {
  multiPushInUrlQuery({
    sort: newSortName,
    order: newSortOrder,
    page: '',
  });
};

/**
 * Concerns of this component:
 *   control url query
 *   fetch /food
 *   fetch /food/group
 *   validate 'group' from url query
**/
class BasicFoodSearch extends Component {
  constructor(props) {
    super(props);

    this.renderOnFulfillment = this.renderOnFulfillment.bind(this);
  }

  render() {
    const { foodFetch, groupFetch } = this.props;
    return (
      <PromiseStateContainer
        ps={PromiseState.all([foodFetch, groupFetch])}
        onFulfillment={this.renderOnFulfillment}
      />
    );
  }

  renderOnFulfillment([foods, groups]) {
    const validGroup = getValidGroup(this.props.group);

    return (
      <div className="BasicFoodSearch">
        <Helmet title="Search for a Food - New Zealand Food Composition Database" />

        <PrintHeader title='SEARCH FOR A FOOD' />

        <SearchNav currentPath={this.props.match.url}>
          <BasicFoodQueryBuilder
            history={this.props.history}
            foods={foods}
            groups={groups}
            urlQuery={this.props.q}
            selectedGroup={validGroup}
            handleSubmit={handleSubmit} />
        </SearchNav>

        <BasicFoodSearchResult
          handlePageChange={handlePageChange}
          handleSortChange={handleSortChange}
          allFoods={foods}
          groups={groups}
          urlQuery={this.props.q}
          selectedGroup={validGroup}
          page={this.props.page}
          size={this.props.size}
          sort={this.props.sort}
          order={this.props.order} />

        <PrintDisclaimer />
      </div>
    );
  }
}

BasicFoodSearch.propTypes = {
  history: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
  q: PropTypes.string,
  group: PropTypes.string,
  page: PropTypes.number,
  size: PropTypes.number,
  sort: PropTypes.string,
  order: PropTypes.string,
  foodFetch: PropTypes.instanceOf(PromiseState),
  groupFetch: PropTypes.instanceOf(PromiseState),
};

const fetch = () => ({
  foodFetch: `${BASE_URL}/food`,
  groupFetch: `${BASE_URL}/food/group`,
});

export default addUrlProps({ urlPropsQueryConfig })(connect(fetch)(BasicFoodSearch));



// WEBPACK FOOTER //
// ./src/components/search/basicFood/BasicFoodSearch.js